module.exports = __webpack_public_path__ + "static/img/UNODC.f737c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/UNODC.png
// module id = M1Pw
// module chunks = 1